"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_FORM_ORDER = exports.DOC_FILES = exports.IMAGE_FILES = exports.REQUIRED = void 0;
var utils_1 = require("./utils");
exports.REQUIRED = {
    value: true,
    message: (0, utils_1.t)("this field is required"),
};
exports.IMAGE_FILES = "image/jpeg,image/png,image/gif";
exports.DOC_FILES = ".pdf,.doc,.docx,.txt,.pdt";
// Used when the backend doesn't send a form order.
exports.DEFAULT_FORM_ORDER = [
    "personal_information",
    "contact_information",
    "academic",
    "total_experience",
    "expected_salary",
    "reference",
    "notice_period",
    "cv_file",
    "photo",
    "languages_json",
    "experiences",
    "references",
    "skills",
    "hobbies",
    "courses",
];
// API
